import type { TimelineItem } from '@repo/shared-types';

/**
 * Id of the most recent call in an oldest-first timeline, or undefined.
 * The multi-chat grid expands only this call's transcript by default —
 * older transcripts stay collapsed so a card's DOM stays bounded.
 */
export const findLatestCallId = (items: TimelineItem[]): string | undefined => {
  for (let i = items.length - 1; i >= 0; i--) {
    if (items[i].kind === 'call') return items[i].id;
  }
  return undefined;
};
